import { createLoader } from '@meteor/data-hooks';
import { instanceClient } from '../../instance/client';
import { withManagementSDK } from '../../management';
import { withAuth } from '../../user';
import { organizationLoader, organizationsLoader } from './organization';

export let projectLoader = createLoader({
  name: 'organizationProject',
  parents: [organizationsLoader, organizationLoader],
  fetch: async (i: { projectId: string }) =>
    await withManagementSDK(i, sdk => sdk.projects.get(i.projectId)),
  mutators: {
    update: (
      i: {
        name?: string;
      },
      { input: { projectId }, output: { organizationId } }
    ) => withManagementSDK({ organizationId }, sdk => sdk.projects.update(projectId, i)),

    // delete: (i: void, { input: { projectId }, output: { organizationId } }) =>
    //   withAuth(() =>
    //     organizationClient.project.delete({
    //       organizationId,
    //       projectId
    //     })
    //   ),

    createInstance: (
      i: {
        name?: string;
        environment: 'development' | 'production';
      },
      { input: { projectId }, output: { organizationId } }
    ) =>
      withAuth(() =>
        instanceClient.instance.create({
          organizationId,
          projectId,
          ...i
        })
      )
  }
});

export let useProject = (projectId: string | undefined | null) => {
  let project = projectLoader.use(projectId ? { projectId } : null);

  return {
    ...project,
    updateMutator: project.useMutator('update'),
    // deleteMutator: project.useMutator('delete'),
    createInstanceMutator: project.useMutator('createInstance')
  };
};
